{
  "delete_schedule_version": {
    "title": "Eliminar el cronograma de disciplina",
    "message": "Al eliminar {{ scheduleVersionName }} también se eliminarán sus eventos, ¿deseas continuar?"
  },
  "show_schedule": "Mostrar horario",
  "delete_schedule": {
    "title": "Eliminar el calendario de la competencia",
    "message": "Al eliminar {{ scheduleVersionName }} también se eliminarán sus calendarios disciplinarios y eventos. ¿Quieres continuar?"
  },
  "toasts": {
    "scheduled_items_start_end_times_affected": "Es posible que las horas de inicio y finalización de algunos artículos programados se hayan visto afectadas"
  },
  "other": {
    "no_items_based_on_selection": {
      "Discipline": "No hay elementos que mostrar en función de la selección disciplinaria.",
      "Day": "No hay artículos para mostrar en función de la selección del lugar."
    }
  },
  "errorMessages": {
    "scheduled_item_must_be_within_session": "El elemento programado debe estar dentro de las horas de inicio y finalización de la sesión",
    "must_end_after_start_time": "El evento debe finalizar después de la hora de inicio"
  },
  "session_form": {
    "medal_header": "Medallas y ceremonias",
    "medal_ceremony": "ceremonia de entrega de medallas",
    "includes_medal_ceremony": "Incluye ceremonia de entrega de medallas"
  },
  "validation": {
    "startTimeValid": "La hora de inicio debe constar de segundos, minutos y horas",
    "startTimeWithinParent": "La hora de inicio debe ser posterior a la hora de inicio de los padres",
    "endTimeBeforeStartTime": "La hora de inicio debe ser anterior a la hora de finalización",
    "endTimeValid": "La hora de finalización debe constar de segundos, minutos y horas",
    "endTimeWithinParent": "La hora de finalización debe ser anterior a la hora de finalización principal"
  },
  "activity": {
    "titleDeleteUnsaved": "Eliminar la fila no guardada",
    "descriptionDeleteUnsaved": "¿Está seguro de que desea descartar esta nueva fila?"
  },
  "divisions": "¿Divisiones",
  "upload_event_blocks": {
    "title": "Subir el contenido del calendario",
    "calendar_level": "Nivel de calendario",
    "delete_existing": "Eliminar los elementos existentes",
    "delete_existing_confirmation_title": "Eliminar los artículos existentes",
    "delete_existing_confirmation_description": "Has seleccionado «Eliminar artículos existentes». Esto eliminará todos los eventos del calendario en la versión de programación que hayas seleccionado y los reemplazará por los valores CSV que hayas proporcionado. Esto no se puede deshacer. ¿Desea continuar?",
    "csv_validation_errors_subtitle": "Errores de validación de CSV"
  },
  "exports": {
    "title": "Opciones de exportación",
    "confirm": "Confirme",
    "cancel": "Cancelar",
    "message": "Seleccione una opción para exportar",
    "downloadTitle": "Descargar",
    "downloadDescription": "La exportación a ODF se descargará a su ordenador",
    "publishedDescription": "La exportación a ODF se publicará en {{ exportDestinationName }}",
    "notAvailable": "No está disponible"
  },
  "key": {
    "title": "Clave para programar los colores de los bloques"
  },
  "data_fields": {
    "event_unit_description": "Unidad de eventos",
    "event_name": "Evento",
    "competition_pahse": "Fase de competición",
    "gender": "Género",
    "medal_type": "Tipo de medalla",
    "ticketing_code": "Código de venta de entradas",
    "ticketed": "¿Con billete",
    "discipline": "Discipl",
    "session_code": "Código de sesión",
    "session_style": "Estilo de sesión",
    "session_type": "Tipo de sesión",
    "venue_code": "Código de lugar",
    "Event": "Evento",
    "Phase": "Fase",
    "Event unit": "Unidad de eventos",
    "Division": "División",
    "Owner": "Dueño",
    "multi_selector": {
      "all": {
        "Discipline": "Todas las disciplinas"
      },
      "none": {
        "Discipline": "Sin disciplinas"
      },
      "x_selected": {
        "Discipline": "{{ count }} disciplinas seleccionadas"
      }
    },
    "view_by_day_label": {
      "Discipline": "Día (Disciplina)"
    }
  },
  "scheduleDoesntExist": {
    "noPermission": "No se ha establecido un cronograma para este proyecto. Tendrá que pedirle a un usuario con privilegios de administrador que lo haga por usted.",
    "createTitle": "Configure el cronograma de este proyecto",
    "createDescription": "No se ha establecido un cronograma para este proyecto. Configure el cronograma con los ajustes que se indican a continuación. Si no estás seguro de cómo configurar el cronograma, ponte en contacto con el servicio de asistencia:"
  },
  "venueEdit": {
    "parentVenue": "Lugar para padres",
    "venueLocationType": "Tipo de ubicación del lugar",
    "topLevelVenueName": "Nivel superior",
    "tryDeleteParent": "Elimine las referencias del identificador principal a esta fila antes de eliminarla",
    "tryEditParent": "{{ count }} sedes hacen referencia a esta como su sede principal. Elimine estas referencias antes de continuar."
  },
  "sidebar": {
    "upload": "Sube bloques de eventos",
    "deleteListItemMessage": "¿Estás seguro de que quieres eliminar todos los elementos de la lista?",
    "deleteListItemTitle": "¿Eliminar los elementos de la lista"
  }
}